/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_AllInputs */

const en_gc_guides_all = /** @type {(inputs: Gc_Guides_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All GridCraft guides`)
};

const zh_gc_guides_all = /** @type {(inputs: Gc_Guides_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部 GridCraft 指南`)
};

/**
* | output |
* | --- |
* | "All GridCraft guides" |
*
* @param {Gc_Guides_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_all = /** @type {((inputs?: Gc_Guides_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_all(inputs)
	return zh_gc_guides_all(inputs)
});
export { gc_guides_all as "gc.guides.all" }